import { Cart } from "../styledComponents/styledComponents";

function CartComp({ children }) {
  return (
    <>
      <Cart>
        <header>
          <h2>Carrinho de Compras</h2>
        </header>
        {children}
      </Cart>
    </>
  );
}

export default CartComp;
